<template>
  <div id="news">
      <div class="page-header header-filter" data-parallax="true" style="background-image: url('static/img/bg3.jpg'); height:50vh">
        <div class="container">
            <div class="row">
              <div class="col-md-8 ml-auto mr-auto">
                  <div class="brand text-center">
                    <h1 class="title" id="hide_edit" @click="edit_news">最新消息</h1>
                    <h3 class="title description">News</h3>
                  </div>
              </div>
            </div>
        </div>
      </div>
      <div class="main">
          <div class="container">
            <div class="section">
              <div class="row">
                <template v-for="(item, index) in displayedPosts">
                  <div class="col-lg-4 col-md-6" :key="index">
                    <router-link :to="{name:'news_detail',params:{ id: item.id, title: item.title, time: item.time, parag: item.parag }}">
                      <div class="card card-blog">
                        <div class="card-header card-header-image">
                            <img class="img" :src="item.title_img">
                        </div>
                        <div class="card-body">
                          <!-- <h6 class="card-category text-success">Legal</h6> -->
                          <h4 class="card-title">{{ item.title }}
                          </h4>
                          <!-- <p class="card-description">
                            Don&apos;t be scared of the truth because we need to restart the human foundation in truth And I love you like Kanye loves Kanye I love Rick Owens&#x2019; bed design but the back is...
                          </p> -->
                        </div>
                        <div class="card-footer ">
                          <div class="author">
                            <!-- <a href="#pablo"> -->
                              <img :src="item.prov_img" class="avatar img-raised">
                              <span>{{ item.prov }}</span>
                            <!-- </a> -->
                          </div>
                          <div class="stats ml-auto">
                            <i class="material-icons">schedule</i> {{ item.time }}
                          </div>
                        </div>
                      </div>
                    </router-link>
                  </div>
                </template>                        
              </div>              
              <!-- =========================================== -->
              <nav aria-label="...">
                <ul class="pagination">
                  <li class="page-item">
                    <span class="page-link" v-if="page != 1" @click="page--">Previous</span>
                  </li>

                  <template v-for="(pageNumber, index) in pages.slice(page-1, page+5)">
                    <li class="page-item" :class="{'active' : page == pageNumber}" :key="index">
                      <a class="page-link" @click="page = pageNumber">{{pageNumber}} </a>
                    </li>
                  </template>

                  <li class="page-item">
                    <a class="page-link" v-if="page < pages.length" @click="page++">Next</a>
                  </li>
                </ul>
              </nav>
              <!-- =========================================== -->
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "news",
  props: [],
  data() {
    return {
      data:[],
			page: 1,
			perPage: 6,
			pages: [],
    };
  },
  methods: {
    getData: function(){
      var vm = this;
      axios
        .get(`/api/getnews`)
        .then(res => {
          vm.data = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    edit_news: function(){
      var vm = this;
      document.querySelector('#hide_edit').addEventListener('click', function (evt) {
          // console.log(evt.detail)

          if(evt.detail === 3){
              vm.$router.push("/edit_news").catch(error => {
                  if (error.name != "NavigationDuplicated") {
                      throw error;
                  }
              });
          }
      });
    },
		setPages () {
      let numberOfPages = Math.ceil(this.data.length / this.perPage);
      // console.log(`numberOfPages : ${numberOfPages}`)
      this.page = 1
      this.pages = []
			for (let index = 1; index <= numberOfPages; index++) {
				this.pages.push(index);
			}
		},
		paginate (posts) {
			let page = this.page;
			let perPage = this.perPage;
			let from = (page * perPage) - perPage;
			let to = (page * perPage);
			return  posts.slice(from, to);
    },

  },
  filters: {},
  computed: {
    displayedPosts () {
			return this.paginate(this.data);
		},
  },
  created() {
    this.getData();
  },
  mounted() {
  },
  components: {},
  watch: {
    data () {
			this.setPages();
		},
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/pages/about/news.vue